//import { _,Obscura,moment } from '../../vendor'

import InboomaBaseFilterableCollection from './InboomaBaseFilterableCollection'

import Order from '../models/Order'
 
export default InboomaBaseFilterableCollection.extend({
  
  collectionName : 'orders',
  model : Order,
  url : '/orders',

  _pagination : {
      current_page : 0,
      has_next_page : true,
      has_prev_page : false,
      count : 0,
      limit : 40,
      sort : 'order_nbr',
      sortDirection : 'desc'
  },

  _filterParams : {},

  filterByStatus (status) {
      return this.addFilter('status', status);
  },

  filterByTag (tag) {
      console.log("add filter tag: ", tag);
      return this.addFilter('tags', tag);
  },

  filterByUser (user_id) {
      return this.addFilter('user_id', user_id);
  },

  filterByQuery (val) {
      return this.addFilter('order_nbr', val);
},

});
